import {
  formatCompact,
  type EnrichedMarket,
} from "@axiome/counter-lp-sdk";

export function PoolCard(props: {
  market: EnrichedMarket;
  selected: boolean;
  onSelect: () => void;
}) {
  const m = props.market;
  const initial = m.symbol.slice(0, 2);

  return (
    <div
      className={`pool-card${props.selected ? " selected" : ""}`}
      onClick={props.onSelect}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && props.onSelect()}
    >
      <div className="pool-top">
        <div className="token-avatar">
          {m.tokenLogo ? (
            <img src={m.tokenLogo} alt={m.symbol} />
          ) : (
            initial
          )}
        </div>
        <div>
          <div className="pool-title">
            {m.symbol}
            <span style={{ color: "var(--muted)", fontWeight: 500 }}> / AXM</span>
          </div>
          <div className="pool-sub">
            {m.tokenName} · комиссия {m.poolFeePercent}% · внос только AXM
          </div>
        </div>
        <div className="apr-badge">
          <strong>{m.effectiveApr.toFixed(1)}%</strong>
          <span>Доходность</span>
        </div>
      </div>
      <div className="pool-metrics">
        <div>
          <span>Доходность пула</span>
          <b>{m.apr.toFixed(1)}%</b>
        </div>
        <div>
          <span>TVL</span>
          <b>{formatCompact(m.tvlAxm)} AXM</b>
        </div>
        <div>
          <span>Объём 24ч</span>
          <b>{formatCompact(m.vol24Axm)}</b>
        </div>
      </div>
    </div>
  );
}
